import { useCallback } from 'react'
import { useTaskActualWorkRepository } from '../../../services/adaptors/taskActualWorkRepositoryAdaptor'
import { UUIDV2 } from '../../../domain/value-object/UUIDV2'
import { DateV2 } from '../../../domain/value-object/DateV2'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'

type TaskActualWork = {
  taskUuid: UUIDV2
  actualDate: DateV2
  hour: number
}
type SaveTaskActualWork = {
  saveMyTaskActualWork: (
    projectUuid: string,
    wbsItemType: WbsItemTypeVO,
    entity: TaskActualWork
  ) => Promise<void>
}

export const useSaveTaskActualWork = (): SaveTaskActualWork => {
  const { saveMine } = useTaskActualWorkRepository()
  const saveMyTaskActualWork = useCallback(
    async (
      projectUuid: string,
      wbsItemType: WbsItemTypeVO,
      entity: TaskActualWork
    ) => {
      await saveMine(projectUuid, wbsItemType, entity)
    },
    [saveMine]
  )
  return { saveMyTaskActualWork }
}
